import type {CrewClaim} from './_requests'

export const isClaimPendingMasterReview = (claim: CrewClaim): boolean => {
  const rankName = (claim.rankName || '').toLowerCase()
  const isMaster = Number(claim.rankId) === 1 || rankName.includes('master') || rankName.includes('captain')
  return !isMaster && (claim.status === 'MASTER_REVIEW_PENDING' ||
    (claim.status === 'DRAFT' && !!claim.submittedAt))
}

export const getClaimMasterRemarks = (remarks?: string | null): string =>
  remarks?.match(/(?:^|\n)\[Master Review\]: ([\s\S]*?)(?=\n\[(?:Master Bulk Review|Office Review)|$)/)?.[1]?.trim() || ''
